module.exports = __webpack_public_path__ + "img/bezlimit1.34563927.png";